import { useCallback, useRef, useState } from 'react';

export function useVideoProgress() {
  const [videoProgress, setVideoProgress] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const playerRef = useRef(null);

  const reset = useCallback(() => {
    setVideoProgress(0);
    setCurrentTime(0);
    setDuration(0);
  }, []);

  const handleTimingUpdate = useCallback(
    ({ currentTime: t, duration: d }) => {
      setCurrentTime(t);
      setDuration(d);
    },
    [],
  );

  const handleProgressUpdate = useCallback(
    ({ currentTime: t, duration: d, videoProgress: p }) => {
      setVideoProgress(p);
      setCurrentTime(t);
      setDuration(d);
    },
    [],
  );

  const handlePlayerReady = useCallback((player) => {
    playerRef.current = player;
  }, []);

  const handleSeek = useCallback(
    (time) => {
      if (!playerRef.current?.seekTo) return;
      playerRef.current.seekTo(time, true);
      setCurrentTime(time);
      if (duration > 0) {
        setVideoProgress((time / duration) * 100);
      }
    },
    [duration],
  );

  return {
    videoProgress,
    currentTime,
    duration,
    handleTimingUpdate,
    handleProgressUpdate,
    handlePlayerReady,
    handleSeek,
    reset,
  };
}
